<template lang="pug">
        .settings(v-if='settings')
                span
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_positionOfUndefined') }}:
                        | {{ $i18n.t('common.common_gameSetting_' + settings.position) }}
                br
                template(v-if='settings.amountOfExamples')
                        span
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_examples') }}:
                                | {{ settings.amountOfExamples }}
                        br
                template(v-else-if='settings.timeLimit')
                        span
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}:
                                | {{ timeLimit }}
                        br
                span
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_actions') }}:
                        | {{ settings.amountOfActions }}
                br
                template(v-if='settings.amountOfUnknowns')
                        span
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_unknowns') }}:
                                | {{ settings.amountOfUnknowns }}
                        br
                template(v-if='settings.stayIn5')
                        span
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_stayIn', {x: 5}) }}:
                                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                        br
                template(v-if='settings.stayIn10')
                        span
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_stayIn', {x: 10}) }}:
                                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                        br
                template(v-if='settings.stayIn20')
                        span
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_stayIn', {x: 20}) }}:
                                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                        br
                template(v-if='settings.stayIn100')
                        span
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_stayIn', {x: 100}) }}:
                                | {{ getStayIn100Settings }}
                        br
                template(v-if='settings.doubleDigits')
                        span
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_doubleDigits') }}:
                                | {{ getDoubleDigitsSetting }}
                        br
                template(v-if='settings.roundDoubleDigits')
                        span
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_roundDoubleDigits') }}:
                                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                        br
                template(v-if='settings.roundTripleDigits')
                        span
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_roundTripleDigits') }}:
                                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                        br
                slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            userId: Number,
        },
        computed: {
            timeLimit() {
                return (
                    this.settings.timeLimit +
                    ' ' +
                    this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', this.settings.timeLimit)
                );
            },
            getStayIn100Settings() {
                if (this.settings.position === 'inAnswer' && this.settings.stayIn100) {
                    let string = this.settings.withJumpThroughTenners
                        ? this.$i18n.t('trainer.trainer_gameFormSetting_withJump').toLowerCase()
                        : this.$i18n.t('trainer.trainer_gameFormSetting_withoutJump').toLowerCase();
                    return string + ' ' + this.$i18n.t('trainer.trainer_gameFormSetting_throwTenners').toLowerCase();
                } else if (this.settings.stayIn100) {
                    return this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated');
                }
                return '';
            },
            getDoubleDigitsSetting() {
                if (this.settings.doubleDigits) {
                    if (this.settings.position === 'inAnswer' && this.settings.plusSingleDigits) {
                        let string = '+ ' + this.$i18n.t('trainer.trainer_gameFormSetting_singleDigits').toLowerCase();
                        return this.settings.withSingleDigitsJump
                            ? string + ' ' + this.$i18n.t('trainer.trainer_gameFormSetting_withJump').toLowerCase()
                            : string + ' ' + this.$i18n.t('trainer.trainer_gameFormSetting_withoutJump').toLowerCase();
                    } else if (this.settings.plusSingleDigits) {
                        return '+ ' + this.$i18n.t('trainer.trainer_gameFormSetting_singleDigits').toLowerCase();
                    } else if (this.settings.position === 'inAnswer' && this.settings.plusRoundDoubleDigits) {
                        return (
                            '+ ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_roundDoubleDigits').toLowerCase() +
                            ' ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_withoutJump').toLowerCase()
                        );
                    } else if (this.settings.plusRoundDoubleDigits) {
                        return '+ ' + this.$i18n.t('trainer.trainer_gameFormSetting_roundDoubleDigits').toLowerCase();
                    }
                }
                return '';
            },
        },
    };
</script>
